import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { message } from 'antd';
import {
  getDailyScheduleContent,
  getAllDailySchedulesByMonth,
  saveChanges,
  saveChangesAsNewVersion,
  sendScheduleToReview,
  approveDailySchedule,
  rejectDailySchedule
} from '../../../services/dailyPlan.service';
import { timeStringToHoursCount } from '../../../util/util';
import { getDailyAll } from '../../../services/dailyPlan.service';

const useDailyPlan = (props) => {
  const { version, loggedUserId, modifiedData } = props;
  const { t } = useTranslation();

  const [loading, setLoading] = useState();
  const [dataSource, setDataSource] = useState();
  const [versions, setVersions] = useState(null);
  const [intervals, setIntervals] = useState();
  const [previousDayLatestVersion, setPreviousDayLatestVersion] = useState();
  const [nextDayLatestVersion, setNextDayLatestVersion] = useState();
  const [nextDayLatestActiveVersion, setNextDayLatestActiveVersion] = useState();

  // const currentVersionScheduleId = versions?.find((el) => el?.value === parseInt(version, 10))?.versionId;

  const fetchDailyAll =  async () => {
    try {
      setLoading(true);
      const response = await getDailyAll();
      setDataSource(response?.data);
  } catch (e) {
      setDataSource(null);
  } finally {
      setLoading(false);
  }
  }

  return {
    loading,
    dataSource,
    fetchDailyAll,
    // versions,
    // getDailyPlanContent,
    // getDailyPlanVersions,
    // intervals,
  }
}

export default useDailyPlan;
